import styles from "../../styles/GeneralButton.module.scss";

interface Props {
  type?: string;
  text: string;
  disabled: boolean;
  onButtonClick: any;
  background: string;
  border: string;
  textColor: string;
  cursor: string;
}

export const GeneralButton = (props: Props) => {
  const {
    type,
    text,
    disabled,
    onButtonClick,
    background,
    border,
    textColor,
    cursor,
  } = props;

  return (
    <div className={styles.container}>
      <input
        onClick={onButtonClick}
        disabled={disabled}
        type={type}
        value={text}
        className={styles.generalButton}
        style={{
          backgroundColor: background,
          border: `1px solid ${border}`,
          color: textColor,
          cursor: cursor,
        }}
      />
    </div>
  );
};
